export enum ArticleAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_ARTICLE_LIST = "ADD_ARTICLE_LIST",
    UPDATE_ARTICLE_LIST = "UPDATE_ARTICLE_LIST",
    UPDATE_ARTICLE_SEARCH_REQ = "UPDATE_ARTICLE_SEARCH_REQ",
    SET_UPDATE_ARTICLE = "SET_UPDATE_ARTICLE",
}